import React from 'react';
import { FiLinkedin, FiInstagram, FiMail } from 'react-icons/fi';
// import logoSjt from '../assets/images/logo_sjt.png';
import logoSjt from '../assets/images/logo_hijau_circle.png';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer__top">
          <div className="footer__brand">
            <div className="footer__logo">
              <img src={logoSjt} alt="PT Solusi Jaringan Teknologi" className="footer__logo-img" />
              <span className="footer__logo-text">Solusi Jaringan Teknologi</span>
            </div>
            <p className="footer__brand-description">
              Menyediakan solusi infrastruktur jaringan dan teknologi informasi terdepan 
              untuk mendukung transformasi digital bisnis Indonesia.
            </p>
            <div className="footer__socials">
              <a href="#" className="footer__social-link" aria-label="LinkedIn">
                <FiLinkedin size={18} />
              </a>
              <a href="#" className="footer__social-link" aria-label="Instagram">
                <FiInstagram size={18} />
              </a>
              <a href="#" className="footer__social-link" aria-label="Email">
                <FiMail size={18} />
              </a>
            </div>
          </div>

          <div className="footer__links-group">
            <h4 className="footer__links-title">Quick Links</h4>
            <ul className="footer__links">
              <li><a href="#beranda" className="footer__link">Beranda</a></li>
              <li><a href="#layanan" className="footer__link">Layanan</a></li>
              <li><a href="#tentang" className="footer__link">Tentang</a></li>
              <li><a href="#proyek" className="footer__link">Proyek</a></li>
            </ul>
          </div>

          <div className="footer__links-group">
            <h4 className="footer__links-title">Layanan</h4>
            <ul className="footer__links">
              <li><a href="#" className="footer__link">Network Infrastructure</a></li>
              <li><a href="#" className="footer__link">Cloud Computing</a></li>
              <li><a href="#" className="footer__link">IT Managed Services</a></li>
              <li><a href="#" className="footer__link">Cyber Security</a></li>
            </ul>
          </div>

          <div className="footer__links-group">
            <h4 className="footer__links-title">Company</h4>
            <ul className="footer__links">
              <li><a href="#" className="footer__link">Karir</a></li>
              <li><a href="#" className="footer__link">Blog</a></li>
              <li><a href="#" className="footer__link">FAQ</a></li>
              <li><a href="#kontak" className="footer__link">Kontak</a></li>
            </ul>
          </div>
        </div>

        <div className="footer__bottom">
          <p className="footer__copyright">
            &copy; {currentYear} Solusi Jaringan Teknologi. All Rights Reserved.
          </p>
          <div className="footer__bottom-links">
            <a href="#" className="footer__bottom-link">Privacy Policy</a>
            <a href="#" className="footer__bottom-link">Terms of Service</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
